package com.swetdot.swetgram.ui.links

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.swetdot.swetgram.ui.design.SwetEmptyState
import com.swetdot.swetgram.ui.design.SwetLoading
import com.swetdot.swetgram.ui.design.SwetTopAppBar
import org.jetbrains.compose.resources.stringResource
import swetgram.shared.generated.resources.Res
import swetgram.shared.generated.resources.link_error_body
import swetgram.shared.generated.resources.link_error_title
import swetgram.shared.generated.resources.link_loading
import swetgram.shared.generated.resources.link_title
import swetgram.shared.generated.resources.profile_try_again

@Composable
fun LinkResolverScreen(
    state: LinkResolverUiState,
    onBack: () -> Unit,
    onRetry: () -> Unit,
    modifier: Modifier = Modifier,
) {
    Column(modifier.fillMaxSize()) {
        SwetTopAppBar(title = stringResource(Res.string.link_title), onBack = onBack)
        if (state.loading) {
            SwetLoading(label = stringResource(Res.string.link_loading))
        } else if (state.failed) {
            SwetEmptyState(
                title = stringResource(Res.string.link_error_title),
                body = stringResource(Res.string.link_error_body),
                actionText = stringResource(Res.string.profile_try_again),
                onAction = onRetry,
            )
        }
    }
}
